import { Col, Row } from "antd";
import { css } from "emotion";
import React from "react";

// import "./style.css";
function LogoMarquee() {
  const scrollers = document.querySelectorAll(".scroller");
  const addAnimation = () => {
    scrollers.forEach((scroller) => {
      scroller.setAttribute("data-animated", true);
    });
  };
  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    addAnimation();
  }
  return (
    <Row
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        marginTop: "10px",
        gap: "10px",
      }}
    >
      {/* <div className="scroller"> */}
      {[...Array(10)].map((logo, index) => (
        <Col>
          <img
            id="image"
            // className="scroller_inner"
            style={{ height: "80px" }}
            src={`/pics/OtherCompLogo/Logo_${index + 1}.webp`}
            alt="Our Clients-1"
          />
        </Col>
      ))}
      {/* </div> */}
    </Row>
  );
}

export default LogoMarquee;
// /** @jsxImportSource @emotion/react */
// import React, { useEffect, useState } from "react";
// import { css } from "@emotion/react";
// import gsap from "gsap";

// const wrapperStyle = css`
//   width: 100%;
//   height: 50px;
//   position: relative;
//   margin: auto;
//   overflow: hidden;

//   &::after {
//     width: 100%;
//     height: 48px;
//     content: "";
//     position: absolute;
//   }
// `;

// const boxStyle = css`
//   width: 50px;
//   height: 50px;
//   position: absolute;
//   line-height: 50px;
//   text-align: center;
// `;

// const boxesStyle = css`
//   position: relative;
//   left: -50px;
// `;

// const navStyle = css`
//   position: relative;
//   text-align: center;
//   color: white;
//   font-size: 20px;
//   margin: 20px 0;
// `;

// const colors = ["#0ae448", "#ff8709", "#9d95ff", "#00bae2"];

// const LogoMarquee = () => {
//   const [isOverflowVisible, setIsOverflowVisible] = useState(false);

//   useEffect(() => {
//     gsap.set(".box", {
//       backgroundColor: "white",
//       x: (i) => i * 50,
//     });

//     gsap.to(".box", {
//       duration: 15,
//       ease: "none",
//       x: "+=1000",
//       modifiers: {
//         x: gsap.utils.unitize((x) => parseFloat(x) % 600),
//       },
//       repeat: -1,
//     });
//   }, []);

//   useEffect(() => {
//     gsap.set(".wrapper", {
//       overflow: isOverflowVisible ? "visible" : "hidden",
//     });
//   }, [isOverflowVisible]);

//   return (
//     <div>
//       <div css={navStyle}>
//         {/* <label>
//           <input
//             type="checkbox"
//             name="overflow"
//             id="overflow"
//             value="1"
//             onChange={(e) => setIsOverflowVisible(e.target.checked)}
//           />
//           Show overflow
//         </label> */}
//       </div>
//       <div
//         css={wrapperStyle}
//         className="wrapper"
//         style={{
//           width: "100%",
//           display: "flex",
//           justifyContent: "space-evenly",
//         }}
//       >
//         <div
//           css={boxesStyle}
//           className="boxes"
//           style={{
//             width: "100%",
//             display: "flex",
//             justifyContent: "space-evenly",
//           }}
//         >
//           {[...Array(12).keys()].map((i) => (
//             <img
//               key={i}
//               css={boxStyle}
//               className="box"
//               src={`/pics/OtherCompLogo/Logo_${i + 1}.webp`}
//               alt={`Our Clients-${i + 1}`}
//             />
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LogoMarquee;
